var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { IconButton } from "../../../../Atoms";
/**
 * logic for first, back, next, last
 */
var TablePaginationActions = function (_a) {
    var count = _a.count, page = _a.page, rowsPerPage = _a.rowsPerPage, onPageChange = _a.onPageChange, toolbarInside = _a.toolbarInside, position = _a.position, inDrawer = _a.inDrawer;
    var handleFirstPageButtonClick = function (event) {
        onPageChange(event, 1);
    };
    var handleBackButtonClick = function (event) {
        onPageChange(event, page - 1);
    };
    var handleNextButtonClick = function (event) {
        onPageChange(event, page + 1);
    };
    var handleLastPageButtonClick = function (event) {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage)));
    };
    // when in drawer use smaller padding
    // TODO: these are iconButtons design should provide a spec for smaller iconButtons we shouldnt hardcode
    var sx = inDrawer ? { "&.MuiIconButton-sizeSmall": { p: 1 } } : undefined;
    /**
     * display for first, back, next, last
     */
    return (_jsxs(Stack, __assign({ gap: toolbarInside ? 0 : 2, direction: "row", sx: { flexShrink: 0, ml: inDrawer ? 0 : 2 } }, { children: [_jsx(IconButton, __assign({ onClick: handleFirstPageButtonClick, disabled: page === 1, "data-testid": "toolbar".concat(position, "-first-icon"), "aria-label": "first page", sx: sx }, { children: _jsx(FirstPageIcon, {}) })), _jsx(IconButton, __assign({ onClick: handleBackButtonClick, disabled: page === 1, "data-testid": "toolbar".concat(position, "-back-icon"), "aria-label": "previous page", sx: sx }, { children: _jsx(KeyboardArrowLeft, {}) })), _jsx(IconButton, __assign({ onClick: handleNextButtonClick, disabled: page >= Math.ceil(count / rowsPerPage), "data-testid": "toolbar".concat(position, "-next-icon"), "aria-label": "next page", sx: sx }, { children: _jsx(KeyboardArrowRight, {}) })), _jsx(IconButton, __assign({ onClick: handleLastPageButtonClick, disabled: page >= Math.ceil(count / rowsPerPage), "data-testid": "toolbar".concat(position, "-last-icon"), "aria-label": "last page", sx: sx }, { children: _jsx(LastPageIcon, {}) }))] })));
};
export default TablePaginationActions;
